import { createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';

interface EffectArgs {
  lookupType: any;
  entitySelector: any;
  service: any;
  callback: any;
  dummyAction: any;
}

export function createEffectModified(context, args: EffectArgs) {
  return createEffect(() => {
    return context.actions$.pipe(
      ofType(args.lookupType),
      withLatestFrom(context.store.select(args.entitySelector)),
      switchMap(([action, data]) => {
        if (!data || (Array.isArray(data) && data.length === 0)) {
          return args.service().pipe(map(args.callback));
        }
        return of(args.dummyAction());
      })
    );
  });
}
